import { useNotificationsState } from "../../NotificationsContext";
import { NotificationsNavButton } from "./NotificationsNavButton";

type Props = {
  className?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export function NotificationsNavButtonContainer({ className, onClick }: Props) {
  const { unreadCount } = useNotificationsState();

  return (
    <NotificationsNavButton
      unreadCount={unreadCount}
      onClick={onClick}
      className={className}
    />
  );
}

export default NotificationsNavButtonContainer;
